import configureScrivito from "./scrivito";
import configureMenu from "./configureMenu";
import configureHistory from "./history";
import configureObjClassForContentType from "./objClassForContentType";
import configureScrivitoContentBrowser from "./scrivitoContentBrowser";
import configureWindowScrivito from "./windowScrivito";

export default function configure(options) {
  configureScrivito(options);
  configureObjClassForContentType();
  if (typeof window !== "undefined") {
    configureHistory();
    configureMenu();
    configureScrivitoContentBrowser();
    configureWindowScrivito();
  }
}
